import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import './i18n';
import { deferNonCriticalScripts } from './utils/deferScripts';
import { reportWebVitals } from './utils/webVitals';

// Optimisation DOM
import { initDOMOptimizations } from './utils/domOptimization';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

// Optimiser le DOM avant le rendu
initDOMOptimizations();

const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);

// Différer les scripts non critiques après le premier rendu
if ('requestIdleCallback' in window) {
  requestIdleCallback(() => {
    deferNonCriticalScripts();
  }, { timeout: 2000 });
} else {
  setTimeout(() => {
    deferNonCriticalScripts();
  }, 2000);
}

// Mesurer et reporter les Core Web Vitals
if ('requestIdleCallback' in window) {
  requestIdleCallback(() => {
    reportWebVitals();
  }, { timeout: 3000 });
} else {
  setTimeout(() => {
    reportWebVitals();
  }, 3000);
}

// Service Worker pour le cache (production uniquement)
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch(() => {
        // Silently fail in production
      });
  });
}